import BrightcovePlayer from './Player'
import PropTypes from 'prop-types'
import React from 'react'
import ResourceLoader from '../../components/ResourceLoader'
import Video from './Video'
import VideoSchemaInjector from './VideoSchemaInjector'
import { T, always, cond } from 'ramda'
import { getLocales, isArabic, isFrench, isHebrew, isPersian } from '../../utilities/locales'

// guessVideoPlayerId :: String -> String
export const guessVideoPlayerId = cond([
  [isFrench, always(process.env.REACT_APP_BRIGHTCOVE_PLAYER_ID_FR)],
  [isHebrew, always(process.env.REACT_APP_BRIGHTCOVE_PLAYER_ID_HE)],
  [isArabic, always(process.env.REACT_APP_BRIGHTCOVE_PLAYER_ID_AR)],
  [isPersian, always(process.env.REACT_APP_BRIGHTCOVE_PLAYER_ID_FA)],
  [T, always(process.env.REACT_APP_BRIGHTCOVE_PLAYER_ID_EN)],
])

// guessI24NewsPlusVideoPlayerId :: String -> String
export const guessI24NewsPlusVideoPlayerId = cond([
  [isFrench, always(process.env.REACT_APP_BRIGHTCOVE_PLAYER_I24NEWS_PLUS_ID_FR)],
  [isHebrew, always(process.env.REACT_APP_BRIGHTCOVE_PLAYER_I24NEWS_PLUS_ID_HE)],
  [isArabic, always(process.env.REACT_APP_BRIGHTCOVE_PLAYER_I24NEWS_PLUS_ID_AR)],
  [isPersian, always(process.env.REACT_APP_BRIGHTCOVE_PLAYER_I24NEWS_PLUS_ID_FA)],
  [T, always(process.env.REACT_APP_BRIGHTCOVE_PLAYER_I24NEWS_PLUS_ID_EN)],
])

const BrightcoveVideoPlayer = ({
  locale,
  videoId,
  isI24NewsPlus = false,
  injectSchema = true,
  loaderSize = 'default',
  ...restProps
}) => {
  const playerId = isI24NewsPlus
    ? guessI24NewsPlusVideoPlayerId(locale)
    : guessVideoPlayerId(locale)

  return (
    <ResourceLoader reducers={ ['brightcoveVideo'] } epics={ ['brightcoveVideo'] }>
      { injectSchema ? <VideoSchemaInjector videoId={ videoId } /> : null }
      <BrightcovePlayer playerId={ playerId } loaderSize={ loaderSize }>
        <Video
          { ...restProps }
          videoId={ videoId }
          playerId={ playerId }
          accountId={  process.env.REACT_APP_BRIGHTCOVE_ACCOUNT_ID }
        />
      </BrightcovePlayer>
    </ResourceLoader>
  )
}

BrightcoveVideoPlayer.propTypes = {
  locale: PropTypes.oneOf(getLocales()).isRequired,
  videoId: PropTypes.string.isRequired,
  isI24NewsPlus: PropTypes.bool,
  injectSchema: PropTypes.bool,
  loaderSize: PropTypes.oneOf(['default', 'small', 'max']),
}

export default BrightcoveVideoPlayer
